import React from 'react'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import SwiftHero from '../../layouts/Technologie/Swiftpage/SwiftHero'
import WhyChooseSwift from '../../layouts/Technologie/Swiftpage/WhyChooseSwift'
import BenefitsSwift from '../../layouts/Technologie/Swiftpage/BenefitsSwift'
import FinalCTA from '../../layouts/FinalCTA'

const Swiftpage = () => {
  return (
    <>
    <Header/>
    <SwiftHero/>
    <WhyChooseSwift/>
    <BenefitsSwift/>
    <FinalCTA/>
    <Footer/>
    </>
  )
}

export default Swiftpage